import script from "./question-answering.vue?vue&type=script&setup=true&lang=js"
export * from "./question-answering.vue?vue&type=script&setup=true&lang=js"

import "./question-answering.vue?vue&type=style&index=0&id=cd4ebfbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd4ebfbe"]])

export default __exports__